// simple-multi-select.component.ts
import { Component, input, output, OnInit, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormatLabelPipe } from "../../core/pipes/format-label/format-label.pipe";

@Component({
  selector: 'ms-multi-select',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, FormatLabelPipe],
  templateUrl: 'multi-select.component.html',
  styleUrl: 'multi-select.component.scss'
})
export class MultiSelectComponent<T extends string | number> implements OnInit {
  public options = input<T[]>([]);
  public selectedOptions = model<T[]>([]);
  public placeholder = input('Select an option');
  public disabled = input(false);
  // While true the dropdown shows a single disabled row with loadingText in place of options, mirroring
  // the "Searching..." row on ms-chart-of-account-typeahead. The native <option disabled> can't be
  // picked, so the host doesn't have to guard the selection handler against a placeholder sneaking in.
  public isLoading = input(false);
  public loadingText = input('Loading...');

  public selectionChange = output<T[]>();
  
  currentSelection: T | '' = '';
  
  public ngOnInit(): void {
  }
  
  public onSelectionChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const selectedValue = target.value as T;

    if (selectedValue && selectedValue !== '' && !this.isOptionSelected(selectedValue)) {
      this.selectedOptions.set([...this.selectedOptions(), selectedValue]);
      this.selectionChange.emit(this.selectedOptions());
    }
    
    // Reset the select to show placeholder
    target.value = '';
  }
  
  public removeOption(index: number): void {
    if (index >= 0 && index < this.selectedOptions().length) {
      this.selectedOptions.set(this.selectedOptions().filter((_, i) => i !== index));
      
      this.selectionChange.emit(this.selectedOptions());
    }
  }
  
  public isOptionSelected(option: T): boolean {
    return this.selectedOptions()?.includes(option) || false;
  }
}
